import { useMemo } from 'react';
import { useQuery } from 'react-query';

export default (providerAccountId, healthcareServiceId) => {
  const { data, isLoading, isSuccess } = useQuery(['GET', `/apis/v2/patient/bookings/provider_locations`, { providerAccountId, healthcareServiceId }], {
    enabled: !!(providerAccountId && healthcareServiceId),
  });

  const options = useMemo(
    () =>
      data?.data.map((x) => ({
        value: x.id,
        label: x.attributes.name,
      })),
    [data],
  );

  return { data: options || [], isLoading, isFetching: isLoading, isSuccess };
};
